import { useTranslation } from 'react-i18next';

/**
 * @param {string} purpose
 * @param {boolean} completed
 * @param {'approver' | 'viewer'} role
 * @returns {string}
 */
export function useGetPurposeText(purpose = '', completed = false, role) {
    const { t } = useTranslation();
    const action = role === 'viewer' ? 'notify' : purpose;

    switch (action) {
        case 'notify':
            return completed ? t('ai:purpose.known.yes') : t('ai:purpose.known.no');
        case 'revise':
            return completed ? t('ai:purpose.revise.done') : t('ai:purpose.revise.action');
        case 'feedback':
            return completed ? t('ai:purpose.feedback.given') : t('ai:purpose.feedback.action');
        case 'check':
            return completed ? t('ai:purpose.checked.yes') : t('ai:purpose.checked.action');
        case 'assess':
            return completed ? t('ai:purpose.assessed.yes') : t('ai:purpose.assessed.action');
        case 'approve':
        default:
            return completed ? t('ai:purpose.approved.yes') : t('ai:purpose.approved.action');
    }
}
